import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  FormFeedback,
  CustomInput,
  Spinner,
  Table,
} from "reactstrap";
import { useFormik, Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import usePersistStoreData from "../../../Components/Hooks/usePersistStoreData";
import CommonLoading from "../../../Components/Common/CommonLoading";
import {
  ProfileDetailThunk,
  list_stateCityThunk,
  reKyc_AccountClosureThunk,
  reKyc_AddBankThunk,
  reKyc_Esign_DocumentDownloadThunk,
  reKyc_UpdateBankThunk,
  reKyc_bankVerifyThunk,
  reKyc_branchDetailsThunk,
} from "../../../slices/thunks";
import { showToast } from "../../../Components/ToastNotification";
import ConfirmationModal from "../../../Components/Modals/ConfirmationModal";
import { clearBranchDetails } from "../../../slices/Re_kyc/BranchDetails/reducer";
import Message from "../../../Components/Common/Message";

const BankDetails = ({
  setSteps,
  steps,
  selectedPrimary,
  setSelectedPrimary,
}) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();

  const token = userData?.token;

  const [loading, setLoading] = useState(false);
  const [fillBankForm, setFillBankForm] = useState(false);

  const [showModal, setShowModal] = useState({
    show: false,
    data: {},
  });

  const [editBank, setEditBank] = useState({});

  const { reKyc_bankVerifyData, reKyc_bankVerifyLoading } = useSelector(
    (state) => state.Re_Kyc_Bank_Verify
  );


  // loading for update bank on next
  const { reKyc_UpdateBankData, reKyc_UpdateBankLoading } = useSelector(
    (state) => state.Re_Kyc_Update_Bank
  );

  // state to store which account user picked

  const handlePrimarySwitch = (account) => {
    // normalize account_no -> account_number so state stays consistent
    const normalized = {
      ...account,
      account_number: account.account_number || account.account_no,
    };
    setSelectedPrimary(normalized);
  };

  const onCloseClick = () => {
    // navigate('/login',{replace:true})
    setShowModal({
      show: false,
      data: {},
    });
    setFillBankForm(false);
    setEditBank({});
    validation.resetForm();
    dispatch(clearBranchDetails());
  };
  const { listStateCityData, listStateCityLoading, listStateCityError } =
    useSelector((state) => state.List_State_City);
  const { reKyc_branchDetailsData, reKyc_branchDetailsLoading } = useSelector(
    (state) => state.Re_Kyc_Fetch_Branch_Details
  );

  // data to append in view bank account after add bank
  const { reKyc_AddBankData, reKyc_AddBankLoading } = useSelector(
    (state) => state.Re_Kyc_Add_Bank
  );

  const validation = useFormik({
    enableReinitialize: true, // Ensures Formik updates when initialValues change
    initialValues: {
      branch: editBank?.name || "",
      bankName: editBank?.name || "",
      accountNumber: editBank?.account_number || "",
      accountType: editBank?.account_type || "",
      ifsc: editBank?.ifsc || "",
      micr: editBank?.micrcode || "",
      // beneficiary: "",
      // isPrimary: editBank?.isPrimary ?? false,
      // terms: false,
      // pin_code: "",
      bank_state: listStateCityData?.state || "",
      bank_city: listStateCityData?.city || "",
    },
    validationSchema: Yup.object({
      // branch: Yup.string().required("Branch is required!"),
      // bankName: Yup.string().required("Bank Name is required!"),
      accountNumber: Yup.string()
        .required("Account Number is required!")
        .matches(/^\d{9,18}$/, "Account Number must be between 9 to 18 digits"),
      accountType: Yup.string().required("Account Type is required!"),
      ifsc: Yup.string()
        .required("IFSC Code is required!")
        .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC Code"),

      // micr: Yup.string()
      //   .required("MICR Number is required!"),

      // beneficiary: Yup.string().required("Beneficiary Name is required!"),
      // isPrimary: Yup.boolean(),
      // pin_code: Yup.string()
      //   .required("Pincode is required!")
      //   .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),

      // bank_state: Yup.string().required("State is required!"),
      // bank_city: Yup.string().required("City is required!"),

      // terms: Yup.boolean().oneOf(
      //   [true],
      //   "You must accept the Terms & Conditions!"
      // ),
    }),
    onSubmit: (values) => {
      setShowModal({
        show: true,
        data: { values },
        title: "Add bank a/c",
        bodyContent: "Are you sure you want to add this account?",
        cancelText: "No",
        confirmText: "Yes",

        handleConfirmBank: async () => {
          try {
            // Step 1: Bank verification
            const verifyRes = await dispatch(
              reKyc_bankVerifyThunk({
                params: {
                  beneficiary_account_no: values?.accountNumber,
                  beneficiary_ifsc: values?.ifsc,
                },
                token,
              })
            );

            // Show verification result message
            if (verifyRes?.payload?.code === 200) {
              // showToast(
              //   verifyRes?.payload?.message || "Verification successful",
              //   "success"
              // );
            } else {
              // showToast(
              //   verifyRes?.payload?.message ||
              //     "Verification failed, please try again later",
              //   "error"
              // );
            }

            // Step 2: Add bank account (always call regardless of verification)
            const addBankRes = await dispatch(
              reKyc_AddBankThunk({
                params: {
                  name: reKyc_branchDetailsData?.bank_name,
                  account_type: values?.accountType,
                  account_no: values?.accountNumber,
                  branch: reKyc_branchDetailsData?.branch_name,
                  micr_no: reKyc_branchDetailsData?.micr,
                  ifsc: values?.ifsc,
                  city: reKyc_branchDetailsData?.district,
                  state: reKyc_branchDetailsData?.state,
                  is_primary: 0,
                  is_verified: verifyRes?.payload?.data?.is_verified ? 1 : 0,
                },
                token,
              })
            );

            // Handle addBank response

            if (addBankRes?.payload?.code === 200) {
              showToast(
                addBankRes?.payload?.message ||
                  "Bank account added successfully",
                "success"
              );

              // Cleanup actions only on successful add
              onCloseClick();
              
            } else {
              showToast(
                
                addBankRes?.error?.message ||
                  "Failed to add bank account, please try again later",
                "error"
              );
              
            }
          } catch (err) {
            showToast(
              err?.message || "Something went wrong, please try again later",
              "error"
            );
          }
        },
      });
    },
  });

  useEffect(() => {
    const { ifsc, accountType, accountNumber } = validation.values;
    const {
      ifsc: ifscError,
      accountType: accountTypeError,
      accountNumber: accountNumberError,
    } = validation.errors;

    //ensure IFSC is touched & valid before calling API
    if (
      ifsc &&
      accountType &&
      accountNumber &&
      validation.touched.ifsc &&
      !ifscError &&
      !accountTypeError &&
      !accountNumberError
    ) {
      dispatch(
        reKyc_branchDetailsThunk({
          params: {
            beneficiary_ifsc: ifsc,
          },
          token,
        })
      )
        .unwrap()
        .then((res) => {
          if (res?.code === 200) {
          } else {
            // reset bank details
            dispatch(clearBranchDetails());
            showToast(
              res?.message || "Something went wrong. please try again later",
              "error"
            );
          }
        })
        .catch((err) => {
          // reset bank details
          showToast(
            err?.message || "Something went wrong. please try again later",
            "error"
          );
          dispatch(clearBranchDetails());
        });
    }
  }, [validation.values.ifsc, validation.errors, validation.touched.ifsc]);

  // update bank api for primary
  const handleUpdateBank = () => {
    // Check if no valid primary account is selected

    if (
      !selectedPrimary || // null / undefined / empty string / 0
      (typeof selectedPrimary === "object" &&
        Object.keys(selectedPrimary).length === 0) // empty object
    ) {
      showToast(
        "Please select one of your bank account as primary account.",
        "error"
      );
      return;
    }

    const formData = new FormData();

    // Decide which banking array to use
    const isNewDetails =
      userData?.personal_details?.new_details?.banking?.length > 0;

    let allBanks = isNewDetails
      ? userData?.personal_details?.new_details?.banking
      : userData?.banking || [];

    if (reKyc_AddBankData) {
      const addBankArray = Array.isArray(reKyc_AddBankData)
        ? reKyc_AddBankData
        : [reKyc_AddBankData];

      allBanks = [...allBanks, ...addBankArray];
    }

    // Loop through chosen banks
    allBanks.forEach((bank, index) => {
      const accNum = bank?.account_no || bank?.account_number;

      // Append to formData
      formData.append(`banks[${index}][name]`, bank?.name || "");
      formData.append(`banks[${index}][account_number]`, accNum || "");
      formData.append(`banks[${index}][ifsc]`, bank?.ifsc || null);
      formData.append(
        `banks[${index}][account_type]`,
        bank?.account_type || ""
      );
      formData.append(
        `banks[${index}][micrcode]`,
        bank?.micrcode || bank?.micr_no || null
      );
      formData.append(
        `banks[${index}][is_primary]`,
        selectedPrimary?.account_number === accNum ||
          selectedPrimary?.account_no === accNum
          ? "1"
          : "0"
      );

      const newBanks = Array.isArray(reKyc_AddBankData)
        ? reKyc_AddBankData
        : [reKyc_AddBankData];

      const isNewBank = newBanks.some(
        (newBank) => (newBank?.account_number || newBank?.account_no) === accNum
      );

      if (!isNewBank) {
        formData.append(
          `banks[${index}][address_line_one]`,
          bank?.address_line_one || ""
        );
        formData.append(
          `banks[${index}][address_line_two]`,
          bank?.address_line_two || ""
        );
        formData.append(
          `banks[${index}][address_line_three]`,
          bank?.address_line_three || ""
        );
      }
    });

    dispatch(
      reKyc_UpdateBankThunk({
        body: formData,
        token,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.code === 200) {
          setSteps(steps + 1);
          showToast(res?.message || "Updated successfully", "success");
          setSelectedPrimary((prev) => ({
            ...prev,
            account_number:
              selectedPrimary.account_number || selectedPrimary.account_no,
          }));
        } else {
          showToast(
            res?.message || "Something went wrong. please try again later",
            "error"
          );
        }
      })
      .catch((err) => {
        // reset bank details
        showToast(
          err?.message || "Something went wrong. please try again later",
          "error"
        );
        dispatch(clearBranchDetails());
      });
  };
  
  return (
    <>
       {userData?.rekcy_appication_status === "rejected" && (
          <div className=" ">
            <Message
              message={userData?.rekcy_appication_sreason}
              color="danger"
              mb={3}
            />
          </div>
        )}            
    {!fillBankForm && (
    <div className="hstack gap-2 justify-content-end">
    <button
      type="button"
      className="btn btn-primary"
      onClick={() => {
        setFillBankForm(true);
      }}
    >
      Add Bank Account
    </button>
  </div>
    )} 
      
      {/* No bank account found */}
      {!(
        userData?.banking?.length > 0 ||
        userData?.personal_details?.new_details?.banking?.length > 0 ||
        reKyc_AddBankData?.length > 0
      ) &&
        !fillBankForm && (
          <div className=" m-0">
            {/* <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setFillBankForm(true);
                }}
              >
                Add Bank Account
              </button>
            </div> */}
            <div className=" mt-3 ">
              <div className="">
                {/* <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                  Manage Bank Details
                </span> */}
              </div>
              <div className="card card-body border text-center mb-0">
                <h4 className="text-center">No Bank Account Found</h4>
                <p className="mb-0 text-center fs-p-bg">
                  Please add at least one bank account to continue.
                </p>
                <p className="text-muted mb-0 pb-0">
                  *Note: Only one account can be used as primary account.
                </p>
              </div>
            </div>
          </div>
        )}

      {/* No data found ends */}

      {/* Bnak details  when profile has default details for primary account  */}
      {!fillBankForm &&
      userData?.banking?.length > 0 &&
      (userData?.personal_details?.new_details?.banking?.length ?? 0) === 0 &&
      userData?.banking?.filter((bank) => bank?.is_primary)?.length > 0 ? (
        <>
          <div className="">
            <div className="mb-3">
              {/* <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                Primary Account
              </span> */}
            </div>
            {userData?.banking
              ?.filter((bank) => bank?.is_primary)
              ?.map((el, i) => (
                <div
                  key={i}
                  className="card card-body px-0 border text-center position-relative mb-3"
                >
                  <Row className=" m-0 p-0">
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <h5 className="mb-1 text-primary text-start me-3">
                          {el?.name}
                        </h5>
                        <p className=" fs-p-sm mb-0 text-start">
                          {el?.account_type === 2 ? "Current" : "Saving"}
                        </p>
                      </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <p className=" fs-p-sm mb-1 text-muted text-start">
                          Bank Account Number
                        </p>
                        <h5 className="mb-0 text-black text-start fw-medium">
                          {el?.account_number}
                        </h5>
                      </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <p className=" fs-p-sm mb-1 text-muted text-start">
                          IFSC
                        </p>
                        <h5 className="mb-0 text-black text-start fw-medium">
                          {el?.ifsc ?? "-"}
                        </h5>
                      </div>
                    </Col>
                    <Col>
                      <div className=" p-0 m-0 d-flex align-items-center justify-content-start gap-3 pt-2">
                        <Label for="isPrimary" check>
                          Choose this account as my primary account
                        </Label>
                        <Input
                          type="radio"
                          color="success"
                          id="isPrimary"
                          name="isPrimary"
                          style={{
                            left: "1.5rem",
                          }}
                          checked={
                            selectedPrimary?.account_number ===
                            (el?.account_number || el?.account_no)
                          }
                          onChange={() => handlePrimarySwitch(el)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}

            {/* {reKyc_AddBankData?.length === 0 &&
              userData?.personal_details?.new_details?.banking?.length === 0 &&
              userData?.banking?.filter((bank) => !bank?.is_primary)?.length ===
                0 && (
                <Col lg={12}>
                  <div className="hstack gap-2 justify-content-end">
                    <button
                      type="button"
                      className="btn btn-soft-secondary"
                      onClick={() => {
                        setSteps(steps - 1);
                      }}
                    >
                      Prev
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={reKyc_UpdateBankLoading}
                      onClick={handleUpdateBank}
                      style={{
                        minWidth: "60px",
                      }}
                    >
                      {reKyc_UpdateBankLoading ? <Spinner size="sm" /> : "Next"}
                    </button>
                  </div>
                </Col>
              )} */}
          </div>
        </>
      ) : null}

      {/* Bnak details  when profile has default details for secondary account  */}

      {!fillBankForm &&
        userData?.banking?.length > 0 &&
        (userData?.personal_details?.new_details?.banking?.length ?? 0) === 0 &&
        userData?.banking?.filter((bank) => !bank?.is_primary)?.length > 0 && (
          <div className="">
            <div className="mb-3">
              {/* <span className="badge bg-primary p-2 fs-p-sm text-uppercase">
                Secondary Account
              </span> */}
            </div>
            {userData?.banking
              ?.filter((bank) => !bank?.is_primary)
              ?.map((el, i) => (
                <div
                  key={i}
                  className="card card-body px-0 border text-center position-relative mb-3"
                >
                  <Row className=" m-0 p-0">
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <h5 className="mb-1 text-primary text-start me-3">
                          {el?.name}
                        </h5>
                        <p className=" fs-p-sm mb-0 text-start">
                          {el?.account_type === 2 ? "Current" : "Saving"}
                        </p>
                      </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <p className=" fs-p-sm mb-1 text-muted text-start">
                          Bank Account Number
                        </p>
                        <h5 className="mb-0 text-black text-start fw-medium">
                          {el?.account_number}
                        </h5>
                      </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <p className=" fs-p-sm mb-1 text-muted text-start">
                          IFSC
                        </p>
                        <h5 className="mb-0 text-black text-start fw-medium">
                          {el?.ifsc ?? "-"}
                        </h5>
                      </div>
                    </Col>
                    <Col>
                      <div className=" p-0 m-0 d-flex align-items-center justify-content-start gap-3 pt-2">
                        <Label for="isPrimary" check>
                          Choose this account as my primary account
                        </Label>
                        <Input
                          type="radio"
                          color="success"
                          id="isPrimary"
                          name="isPrimary"
                          style={{
                            left: "1.5rem",
                          }}
                          checked={
                            selectedPrimary?.account_number ===
                            (el?.account_number || el?.account_no)
                          }
                          onChange={() => handlePrimarySwitch(el)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
          </div>
        )}

      {/* Bnak details of primary when profile has new details has bank data   */}
      {!fillBankForm &&
      userData?.personal_details?.new_details?.banking?.length > 0 &&
      userData?.personal_details?.new_details?.banking?.filter(
        (bank) => bank?.is_primary
      )?.length > 0 ? (
        <>
          <div className="">
            <div className="mb-3">
              {/* <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                Primary Account
              </span> */}
            </div>
            {userData?.personal_details?.new_details?.banking
              ?.filter((bank) => bank?.is_primary)
              ?.map((el, i) => (
                <div
                  key={i}
                  className="card card-body px-0 border text-center position-relative mb-3"
                >
                  <Row className=" m-0 p-0">
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <h5 className="mb-1 text-primary text-start me-3">
                          {el?.name}
                        </h5>
                        <p className=" fs-p-sm mb-0 text-start">
                          {el?.account_type === 2 ? "Current" : "Saving"}
                        </p>
                      </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <p className=" fs-p-sm mb-1 text-muted text-start">
                          Bank Account Number
                        </p>
                        <h5 className="mb-0 text-black text-start fw-medium">
                          {el?.account_no}
                        </h5>
                      </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <p className=" fs-p-sm mb-1 text-muted text-start">
                          IFSC
                        </p>
                        <h5 className="mb-0 text-black text-start fw-medium">
                          {el?.ifsc ?? "-"}
                        </h5>
                      </div>
                    </Col>
                    <Col>
                      <div className=" p-0 m-0 d-flex align-items-center justify-content-start gap-3 pt-2">
                        <Label for="isPrimary" check>
                          Choose this account as my primary account
                        </Label>
                        <Input
                          type="radio"
                          color="success"
                          id="isPrimary"
                          name="isPrimary"
                          style={{
                            left: "1.5rem",
                          }}
                          checked={
                            selectedPrimary?.account_no === el?.account_no
                          }
                          onChange={() => handlePrimarySwitch(el)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
          </div>
        </>
      ) : null}

      {/* Bnak details of secondary  when profile has new details has bank data   */}
      {!fillBankForm &&
        userData?.personal_details?.new_details?.banking?.length > 0 &&
        userData?.personal_details?.new_details?.banking?.filter(
          (bank) => !bank?.is_primary
        )?.length > 0 && (
          <div className="">
            <div className="mb-3">
              {/* <span className="badge bg-primary p-2 fs-p-sm text-uppercase">
                Secondary Accounts
              </span> */}
            </div>
            {userData?.personal_details?.new_details?.banking
              ?.filter((bank) => !bank?.is_primary)
              ?.map((el, i) => (
                <div
                  key={i}
                  className="card card-body px-0 border text-center position-relative mb-3"
                >
                  <Row className=" m-0 p-0">
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <h5 className="mb-1 text-primary text-start me-3">
                          {el?.name}
                        </h5>
                        <p className=" fs-p-sm mb-0 text-start">
                          {el?.account_type === 2 ? "Current" : "Saving"}
                        </p>
                      </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <p className=" fs-p-sm mb-1 text-muted text-start">
                          Bank Account Number
                        </p>
                        <h5 className="mb-0 text-black text-start fw-medium">
                          {el?.account_no}
                        </h5>
                      </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} sm={12}>
                      <div className="d-flex flex-column">
                        <p className=" fs-p-sm mb-1 text-muted text-start">
                          IFSC
                        </p>
                        <h5 className="mb-0 text-black text-start fw-medium">
                          {el?.ifsc ?? "-"}
                        </h5>
                      </div>
                    </Col>
                    <Col>
                      <div className=" p-0 m-0 d-flex align-items-center justify-content-start gap-3 pt-2">
                        <Label for="isPrimary" check>
                          Choose this account as my primary account
                        </Label>
                        <Input
                          type="radio"
                          color="success"
                          id="isPrimary"
                          name="isPrimary"
                          style={{
                            left: "1.5rem",
                          }}
                          checked={
                            selectedPrimary?.account_number ===
                            (el?.account_number || el?.account_no)
                          }
                          onChange={() => handlePrimarySwitch(el)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
          </div>
        )}

      {(Array.isArray(reKyc_AddBankData)
        ? reKyc_AddBankData.length > 0
        : reKyc_AddBankData && Object.keys(reKyc_AddBankData).length > 0) &&
        !fillBankForm && (
          <>
            {reKyc_AddBankData?.map((item, index) => (
              <div
                className="card card-body px-0 border text-center position-relative my-3"
                key={index}
              >
                <Row className=" m-0 p-0">
                  <Col xxl={4} xl={4} lg={4} sm={12}>
                    <div className="d-flex flex-column">
                      <h5 className="mb-1 text-primary text-start me-3">
                        {item?.name}
                      </h5>
                      <p className=" fs-p-sm mb-0 text-start">
                        {item?.account_type === 2 ? "Current" : "Saving"}
                      </p>
                    </div>
                  </Col>
                  <Col xxl={4} xl={4} lg={4} sm={12}>
                    <div className="d-flex flex-column">
                      <p className=" fs-p-sm mb-1 text-muted text-start">
                        Bank Account Number
                      </p>
                      <h5 className="mb-0 text-black text-start fw-medium">
                        {item?.account_no}
                      </h5>
                    </div>
                  </Col>
                  <Col xxl={4} xl={4} lg={4} sm={12}>
                    <div className="d-flex flex-column">
                      <p className=" fs-p-sm mb-1 text-muted text-start">
                        IFSC
                      </p>
                      <h5 className="mb-0 text-black text-start fw-medium">
                        {item?.ifsc ?? "-"}
                      </h5>
                    </div>
                  </Col>
                  <Col>
                    <div className=" p-0 m-0 d-flex align-items-center justify-content-start gap-3 pt-2">
                      <Label for="isPrimary-rekyc" check>
                        Choose this account as my primary account
                      </Label>
                      <Input
                        type="radio"
                        color="success"
                        id="isPrimary-rekyc"
                        name="isPrimary"
                        checked={
                          selectedPrimary?.account_number ===
                          (item?.account_number || item?.account_no)
                        }
                        onChange={() => handlePrimarySwitch(item)}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          </>
        )}
      {(userData?.banking?.length > 0 ||
        userData?.personal_details?.new_details?.banking?.length > 0 ||
        reKyc_AddBankData?.length > 0) &&
        !fillBankForm && (
          <Col lg={12}>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-soft-secondary"
                onClick={() => {
                  setSteps(steps - 1);
                }}
              >
                Prev
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={reKyc_UpdateBankLoading}
                onClick={handleUpdateBank}
                style={{
                  minWidth: "60px",
                }}
              >
                {reKyc_UpdateBankLoading ? <Spinner size="sm" /> : "Next"}
              </button>
            </div>
          </Col>
        )}

      {/* Add bank account form */}
      {fillBankForm && (
        <div className=" m-0">
          <div className="mb-3">
            <span className="badge bg-success p-2 fs-p-sm text-uppercase">
              Add Bank Details
            </span>
          </div>
          <Form onSubmit={validation.handleSubmit}>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label for="accountNumber">Bank Account Number</Label>
                  <div className="position-relative auth-pass-inputgroup mb-3">
                    <Input
                      name="accountNumber"
                      value={validation.values.accountNumber}
                      // type={
                      //   passwordShow
                      //     ? "text"
                      //     : "password"
                      // }
                      type="text"
                      className="form-control pe-5"
                      placeholder="Enter Account Number"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.accountNumber &&
                        validation.errors.accountNumber
                      }
                    />
                    <FormFeedback>
                      {validation.errors.accountNumber}
                    </FormFeedback>
                    {/* <button
                    className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                    onClick={() =>
                      setPasswordShow(!passwordShow)
                    }
                    type="button"
                  >
                    <i
                      className={`ri-eye-fill align-middle ${
                        validation.touched
                          .accountNumber &&
                        validation.errors
                          .accountNumber
                          ? "me-3"
                          : ""
                      }`}
                    />
                  </button> */}
                  </div>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label for="ifsc">IFSC</Label>
                  <Input
                    type="text"
                    id="ifsc"
                    name="ifsc"
                    placeholder="Enter IFSC Number"
                    value={validation.values.ifsc}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={validation.touched.ifsc && validation.errors.ifsc}
                  >
                    <option value="">Select IFSC</option>
                  </Input>
                  <FormFeedback>{validation.errors.ifsc}</FormFeedback>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="accountType">Account Type</Label>
                  <Input
                    type="select"
                    id="accountType"
                    name="accountType"
                    value={validation.values.accountType}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.accountType &&
                      validation.errors.accountType
                    }
                  >
                    <option value="">Select Account Type</option>
                    <option value="1">Saving</option>
                    <option value="2">Current</option>
                  </Input>
                  <FormFeedback>{validation.errors.accountType}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="bankName">Bank Name</Label>
                  <Input
                    id="bankName"
                    name="bankName"
                    value={
                      reKyc_branchDetailsLoading
                        ? "Loading..."
                        : reKyc_branchDetailsData?.bank_name
                    }
                    disabled
                  ></Input>
                  <FormFeedback>{validation.errors.bankName}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="branch">Branch</Label>
                  <Input
                    id="branch"
                    name="branch"
                    value={
                      reKyc_branchDetailsLoading
                        ? "Loading..."
                        : reKyc_branchDetailsData?.branch_name
                    }
                    disabled
                  ></Input>
                  <FormFeedback>{validation.errors.branch}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label for="micr">MICR Number</Label>
                  <div className="position-relative auth-pass-inputgroup mb-3">
                    <Input
                      name="micr"
                      value={
                        reKyc_branchDetailsLoading
                          ? "Loading..."
                          : reKyc_branchDetailsData?.micr
                      }
                      disabled
                      className="form-control pe-5"
                      placeholder="Enter MICR Number"
                    />
                  </div>
                  <FormFeedback>{validation.errors.micr}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label for="bank_city">City</Label>
                  <Input
                    id="bank_city"
                    name="bank_city"
                    value={
                      reKyc_branchDetailsLoading
                        ? "Loading..."
                        : reKyc_branchDetailsData?.district
                    }
                    disabled
                  ></Input>
                  <FormFeedback>{validation.errors.bank_city}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label for="bank_state">State</Label>
                  <Input
                    id="bank_state"
                    name="bank_state"
                    value={
                      reKyc_branchDetailsLoading
                        ? "Loading..."
                        : reKyc_branchDetailsData?.state
                    }
                    disabled
                  ></Input>
                  <FormFeedback>{validation.errors.bank_state}</FormFeedback>
                </FormGroup>
              </Col>

              <Col md={12} className="mt-1">
                <div className="hstack gap-2 justify-content-start">
                  <Button
                    color="primary"
                    type="submit"
                    disabled={reKyc_branchDetailsLoading}
                  >
                    Save Bank Details
                  </Button>
                  <button
                    type="button"
                    className="btn btn-soft-secondary"
                    onClick={() => {
                      setFillBankForm(false);
                      setEditBank();
                      validation.resetForm();
                      dispatch(clearBranchDetails());
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      )}
      {showModal?.show && (
        <ConfirmationModal
          confirm_modal={showModal?.show}
          close_confirmModal={onCloseClick}
          title={showModal?.title}
          bodyContent={showModal?.bodyContent}
          cancelText={showModal?.cancelText}
          confirmText={showModal?.confirmText}
          handleConfirmDelete={showModal?.handleConfirmBank}
          loading={reKyc_bankVerifyLoading}
          resetForm={validation.resetForm}
        />
      )}
    </>
  );
};

export default BankDetails;
